<template>
  <a-spin
    class="loading"
    :spinning="!!loading"
    size="large"
  />
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
};
</script>

<style lang="less" scoped>
.loading {
  position: fixed;
  z-index: 9999;
  top: 25%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
}
</style>
